import { createDeepEqualSelector } from '@mb/redux/utils';
import type { Event } from '@mb/types';
import { RootState } from '../store';

export const eventSelector = (state: RootState): RootState['event'] =>
  state.event;

const getTime = (eventDate: string | null) => {
  const date = eventDate
    ? new Date(Date.parse(eventDate.replace(/-/g, '/')))
    : false;
  return date ? date.getTime() : false;
};

const notEndedEvent = (event: Event) => {
  if (event?.end_date) {
    const currentDate = new Date().getTime();
    const endDate = getTime(event.end_date);
    return endDate && currentDate < endDate;
  }
  return true;
};

export const eventDataSelector = createDeepEqualSelector(
  eventSelector,
  (event) => event.event,
);

export const eventsDataSelector = createDeepEqualSelector(
  eventSelector,
  (event) =>
    event.events?.filter((event) => event.enabled && notEndedEvent(event)) ??
    [],
);

export const eventLoadedSelector = createDeepEqualSelector(
  eventSelector,
  (event) => event.eventLoaded,
);

export const eventsLoadedSelector = createDeepEqualSelector(
  eventSelector,
  (event) => event.eventsLoaded,
);

export const eventErrorSelector = createDeepEqualSelector(
  eventSelector,
  (event) => event.eventError,
);

export const eventsErrorSelector = createDeepEqualSelector(
  eventSelector,
  (event) => event.eventsError,
);
